const mutations = {
  SET_POSTER(state, payload){
    state.poster = payload;
  },
  SET_NEWS(state, payload){
    state.news = payload.sort((a,b) => new Date(b.created_at) - new Date(a.created_at));
  }
};

export default mutations;